// src/features/auth/api/authApi.js
import httpClient from "../../../shared/api/httpClient";

const AUTH_BASE = "/auth";

export const AuthApi = {
  login: ({ usuario, password, client = "WEB", rolId }) =>
    httpClient.post(`${AUTH_BASE}/login`, {
      email: usuario, // backend hoy valida IsEmail() y busca por email
      password,
      client,
      rolId: rolId ?? undefined,
    }),

  refresh: ({ refreshToken }) => httpClient.post(`${AUTH_BASE}/refresh`, { refreshToken }),

  getMe: () => httpClient.get(`${AUTH_BASE}/me`),

  selectContext: ({ licenseId, branchId, employeeRoleId }) =>
    httpClient.post(`${AUTH_BASE}/select-context`, {
      licenseId,
      branchId,
      employeeRoleId,
    }),

  requestPasswordReset: ({ email }) =>
    httpClient.post("/auth/password-reset/request", { email }),
  
  confirmPasswordReset: ({ email, code, newPassword }) =>
    httpClient.post("/auth/password-reset/confirm", {
      email,
      code,
      newPassword,
    }),
};

export default AuthApi;
